import React from 'react'

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      title: 'Open Camera',
      description: 'Launch AnglersAI and point your camera at your catch.',
      image: 'https://images.unsplash.com/photo-1516371535707-512a1e83bb9a?w=400&h=300&fit=crop'
    },
    {
      number: '02',
      title: 'Place Reference',
      description: 'Place a reference object or use AR markers for accurate measurement.',
      image: 'https://images.unsplash.com/photo-1545450660-3378a7f3a364?w=400&h=300&fit=crop'
    },
    {
      number: '03',
      title: 'Measure & Identify',
      description: 'Get instant measurements and AI-powered species identification.',
      image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=300&fit=crop'
    },
    {
      number: '04',
      title: 'Save & Share',
      description: 'Save to your fishing log and share with your fishing buddies.',
      image: 'https://images.unsplash.com/photo-1600298881974-6be191ceeda1?w=400&h=300&fit=crop'
    }
  ]

  return (
    <section id="how-it-works" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Measure and identify your catch in seconds with our simple 4-step process.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="relative mb-6 overflow-hidden rounded-2xl shadow-lg">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-48 object-cover transform hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4 bg-primary-600 text-white text-2xl font-bold w-12 h-12 rounded-full flex items-center justify-center">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-24 -right-4 w-8 text-gray-300">
                  <svg fill="currentColor" viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorks